// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FilterFilledSvg from "@ant-design/icons-svg/es/asn/FilterFilled";
import AntdIcon from '../components/AntdIcon';

var FilterFilled = function FilterFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FilterFilledSvg
  }));
};

FilterFilled.displayName = 'FilterFilled';
export default /*#__PURE__*/React.forwardRef(FilterFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/es/icons/FilterFilled.js
// module id = 1102
// module chunks = 0